import { RouteWrapper } from '../../component';
import MileStones from '../../component/milestones';
import NavigationHeader from '../../component/navigation_header';
import ScreenBackgroundWrapper from '../../component/screen_background_wrapper';
import XpLevels from '../../component/xplevels';
import Constants from '../../constants';
import './index_mWeb.css';
interface Props {
  onClickBack: any;
}
const DailyRewardsMWeb = ({ onClickBack }: Props) => {
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <NavigationHeader onClickBack={onClickBack} title={'Daily Rewards'} bgColor />
        <div className={`dailyRewardPage__container__mWeb`} id="dailyrewards">
          <div className="dailyRewardPage">
            <XpLevels />
            <div className="dailyRewardPage__earnMoreXpSec">
              <div className="dailyRewardPage__milestones__header__mWeb">
                <p className="dailyRewardPage__milestones__header__txt">
                  Earn more <Constants.Svgs.Xp style={{ marginLeft: '5px' }} />
                </p>
                <p className="dailyRewardPage__milestones_header_desc">
                  Play these games to earn more XP points and win more daily rewards!
                </p>
              </div>
              <MileStones />
            </div>
          </div>
        </div>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default DailyRewardsMWeb;
